import React from 'react';
import { useQuery } from 'react-query';
import { get_all_unread_notifications } from './api/notificationApi';
import { useNavigate } from 'react-router-dom';

interface NotificationItem {
    id: number | string;
    data: {
        leave_id?: number;
        status?: string;
        from_date?: string;
        to_date?: string;
        approval_message?: string | null;
    };
    read_at: string | null;
    created_at: string;
}

const formatDateTime = (dateTimeString: string | null): string => {
    if (!dateTimeString) return '';
    try {
        return new Date(dateTimeString).toLocaleString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    } catch (e) {
        return dateTimeString || '';
    }
};

function Notification() {
    const navigate = useNavigate();

    // const { data, isLoading, isError, error, isFetching } = useQuery(
    //     ['get_unread_notifications'],
    //     get_all_unread_notifications,
    //     {
    //         refetchInterval: 5000, // Poll every 5 seconds
    //     }
    // );

    // const unreadNotifications: NotificationItem[] = data?.data || [];
    // const showViewAllButton = unreadNotifications.length > 5;
    // const topFiveNotifications = unreadNotifications.slice(0, 5);

    return (
        <div className="container my-4">
            <div className="card shadow-sm">
                <div className="card-header bg-light py-3">
                    <h2 className="h5 mb-0">Unread Notifications</h2>
                </div>
{/* 
                <div className="card-body p-0">
                    {isLoading || isFetching ? (
                        <div className="text-center p-5">
                            <div className="spinner-border text-primary" role="status"></div>
                            <p className="mt-2 text-muted">Loading...</p>
                        </div>
                    ) : isError ? (
                        <div className="alert alert-danger text-center m-4" role="alert">
                            Error: {(error as Error).message}
                        </div>
                    ) : unreadNotifications.length === 0 ? (
                        <div className="text-center p-5">
                            <p className="text-muted">You're all caught up 🎉</p>
                        </div>
                    ) : (
                        <ul className="list-group list-group-flush">
                            {topFiveNotifications.map((notification) => {
                                const data = notification.data;
                                return (
                                    <li key={notification.id} className="list-group-item py-3 px-3">
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h6 className="mb-1 fw-semibold">Leave Request</h6>
                                                <p className="mb-1 small">
                                                    {data.from_date} → {data.to_date}
                                                </p>
                                                <p className="mb-1 small">
                                                    Status:{' '}
                                                    <span
                                                        className={
                                                            data.status === 'Approved'
                                                                ? 'text-success fw-medium'
                                                                : 'text-danger fw-medium'
                                                        }
                                                    >
                                                        {data.status}
                                                    </span>
                                                </p>
                                                {data.approval_message && (
                                                    <p className="mb-0 small text-muted fst-italic">
                                                        Message: “{data.approval_message}”
                                                    </p>
                                                )}
                                            </div>
                                            <small className="text-muted">
                                                {formatDateTime(notification.created_at)}
                                            </small>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>

                {showViewAllButton && (
                    <div className="card-footer text-center">
                        <button
                            onClick={() => navigate('/notifications')}
                            className="btn btn-outline-primary btn-sm"
                        >
                            View All Notifications
                        </button>
                    </div>
                )} */}
            </div>
        </div>
    );
}

export default Notification;
